<template>
  <FlotoModule>
    <template v-if="hasPermission">
      <RouterView :key="$route.fullPath" />
    </template>
  </FlotoModule>
</template>

<script>
import { PreferenceComputed } from '@state/modules/preference'
export default {
  name: 'EventNotificationsModule',
  page() {
    return {
      title: this.$t('event_notifications'),
    }
  },
  data() {
    return {
      hasPermission: false,
    }
  },
  computed: {
    ...PreferenceComputed,
  },
  created() {
    // if user doesn't have permission to handle admin automation section
    if (
      this.$route.params.moduleName === this.$constants.SERVICE_CATALOG &&
      this.myAllowedModules.indexOf('admin.service_catalog') === -1
    ) {
      return this.$router.replace({ name: '404' })
    }
    if (
      this.myAllowedModules.indexOf('admin.automation') === -1 &&
      this.$route.params.moduleName !== this.$constants.SERVICE_CATALOG
    ) {
      return this.$router.replace({ name: '404' })
    }
    this.hasPermission = true
  },
}
</script>
